// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3103C","tabsBox":"styles_tabsBox__1UQWg","createButton":"styles_createButton__1dhW2"};